import { ReactNode } from "react";
import { useRouter } from "next/router";

import useAuth from "../lib/useAuth";
import Link from "next/link";
import { useAuth as useClerkAuth } from '@clerk/nextjs'

//export default function AuthContent({ children }: { children: ReactNode }) {

export default function AuthContent(props: { hideLogon?: boolean, children: ReactNode }) {

    const { isSignedIn   } = useClerkAuth();

    const router = useRouter();

    if (isSignedIn) {
        return <>{props.children}</>;
    }

    if (!props.hideLogon)
    {
        let link = "/log-in?redirect_to=" + encodeURIComponent(router.asPath);
        return <p>You must be logged in to see this page. You can log in <Link href={link}>here</Link>.</p>;
    }
    else
    {
        return <></>
    }
}